<template>
  <section class="sample-info">
    <div class="metals">
      <h3 class="section-title">Metals</h3>
      <div class="metals-wrapper">
        <dl>
          <dt>Copper (Cu)</dt>
          <dd :class="`severity-id-${coolantSample.copperSeverity.toLowerCase()}`">
            {{ coolantSample.copperDisplay }}
          </dd>
          <dt>Silicon (Si)</dt>
          <dd :class="`severity-id-${coolantSample.siliconSeverity.toLowerCase()}`">
            {{ coolantSample.siliconDisplay }}
          </dd>
          <dt>Calcium (Ca)</dt>
          <dd :class="`severity-id-${coolantSample.calciumSeverity.toLowerCase()}`">
            {{ coolantSample.calciumDisplay }}
          </dd>
          <dt>Zinc (Zn)</dt>
          <dd :class="`severity-id-${coolantSample.zincSeverity.toLowerCase()}`">
            {{ coolantSample.zincDisplay }}
          </dd>
          <dt>Molybdenum (Mo)</dt>
          <dd :class="`severity-id-${coolantSample.molybdenumSeverity.toLowerCase()}`">
            {{ coolantSample.molybdenumDisplay }}
          </dd>
          <dt>Sodium (Na)</dt>
          <dd :class="`severity-id-${coolantSample.sodiumSeverity.toLowerCase()}`">
            {{ coolantSample.sodiumDisplay }}
          </dd>
        </dl>
        <dl>
          <dt>Iron (Fe)</dt>
          <dd :class="`severity-id-${coolantSample.ironSeverity.toLowerCase()}`">
            {{ coolantSample.ironDisplay }}
          </dd>
          <dt>Aluminum (Al)</dt>
          <dd :class="`severity-id-${coolantSample.aluminumSeverity.toLowerCase()}`">
            {{ coolantSample.aluminumDisplay }}
          </dd>
          <dt>Lead (Pb)</dt>
          <dd :class="`severity-id-${coolantSample.leadSeverity.toLowerCase()}`">
            {{ coolantSample.leadDisplay }}
          </dd>
          <dt>Magnesium (Mg)</dt>
          <dd :class="`severity-id-${coolantSample.magnesiumSeverity.toLowerCase()}`">
            {{ coolantSample.magnesiumDisplay }}
          </dd>
          <dt>Phosphorus (P)</dt>
          <dd :class="`severity-id-${coolantSample.phosphorusSeverity.toLowerCase()}`">
            {{ coolantSample.phosphorusDisplay }}
          </dd>
          <dt>Boron (B)</dt>
          <dd :class="`severity-id-${coolantSample.boronSeverity.toLowerCase()}`">
            {{ coolantSample.boronDisplay }}
          </dd>
          <dt>Potassium (K)</dt>
          <dd :class="`severity-id-${coolantSample.potassiumSeverity.toLowerCase()}`">
            {{ coolantSample.potassiumDisplay }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="fluid-properties">
      <h3 class="section-title">Fluid Properties</h3>
      <div class="fluid-properties-wrapper">
        <dl>
          <dt>Nitrites</dt>
          <dd :class="`severity-id-${coolantSample.nitriteSeverity.toLowerCase()}`">
            {{ coolantSample.nitriteDisplay }}
          </dd>
          <dt>Color</dt>
          <dd :class="`severity-id-${coolantSample.colorSeverity.toLowerCase()}`">
            {{ coolantSample.color }}
          </dd>
          <dt>Clarity</dt>
          <dd :class="`severity-id-${coolantSample.claritySeverity.toLowerCase()}`">
            {{ coolantSample.clarityResultName }}
          </dd>
          <dt>D1287 pH</dt>
          <dd :class="`severity-id-${coolantSample.phSeverity.toLowerCase()}`">
            {{ coolantSample.phDisplay }}
          </dd>
          <dt>Boil Pt.</dt>
          <dd></dd>
          <dt>TDS</dt>
          <dd></dd>
          <dt>Glycol</dt>
          <dd>{{ coolantSample.antifreezePercent }}</dd>
          <dt>Freeze Pt.</dt>
          <dd :class="`severity-id-${coolantSample.freezePointSeverity.toLowerCase()}`">
            {{ coolantSample.freezePointDisplay }}
          </dd>
        </dl>
        <dl>
          <dt>% Glycol</dt>
          <dd>{{ coolantSample.antifreezePercentSign }}</dd>
          <dt>Hardness</dt>
          <dd :class="`severity-id-${coolantSample.hardnessSeverity.toLowerCase()}`">
            {{ coolantSample.hardnessDisplay }}
          </dd>
          <dt>Odor</dt>
          <dd :class="`severity-id-${coolantSample.odorSeverity.toLowerCase()}`">
            {{ coolantSample.odor }}
          </dd>
          <dt>Mag Precip</dt>
          <dd :class="`severity-id-${coolantSample.magneticPrecipitateSeverity.toLowerCase()}`">
            {{ coolantSample.magneticPrecipitateResult }}
          </dd>
          <dt>Non-Mag Precip</dt>
          <dd :class="`severity-id-${coolantSample.nonMagneticPrecipitateSeverity.toLowerCase()}`">
            {{ coolantSample.nonMagneticPrecipitateResult }}
          </dd>
          <dt>Fuel</dt>
          <dd :class="`severity-id-${coolantSample.fuelSeverity.toLowerCase()}`">
            {{ coolantSample.fuel }}
          </dd>
          <dt>Foal</dt>
          <dd :class="`severity-id-${coolantSample.foamSeverity.toLowerCase()}`">
            {{ coolantSample.foam }}
          </dd>
          <dt>Oil</dt>
          <dd :class="`severity-id-${coolantSample.oilSeverity.toLowerCase()}`">
            {{ coolantSample.oilResultName }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="advanced-fluid-properties">
      <h3 class="no-wrap section-title">Advanced Fluid Properties</h3>
      <dl>
        <dt>Nitrates</dt>
        <dd :class="`severity-id-${coolantSample.nitrateSeverity.toLowerCase()}`">
          {{ coolantSample.nitrateDisplay }}
        </dd>
        <dt>Phosphate</dt>
        <dd :class="`severity-id-${coolantSample.phosphateSeverity.toLowerCase()}`">
          {{ coolantSample.phosphateDisplay }}
        </dd>
        <dt>Sulfate</dt>
        <dd :class="`severity-id-${coolantSample.sulfateSeverity.toLowerCase()}`">
          {{ coolantSample.sulfateDisplay }}
        </dd>
        <dt>Oxalate</dt>
        <dd :class="`severity-id-${coolantSample.oxalateSeverity.toLowerCase()}`">
          {{ coolantSample.oxalateDisplay }}
        </dd>
        <dt>Acetate</dt>
        <dd :class="`severity-id-${coolantSample.acetateSeverity.toLowerCase()}`">
          {{ coolantSample.acetateDisplay }}
        </dd>
        <dt>Formate</dt>
        <dd :class="`severity-id-${coolantSample.formateSeverity.toLowerCase()}`">
          {{ coolantSample.formateDisplay }}
        </dd>
        <dt>Glycolate</dt>
        <dd :class="`severity-id-${coolantSample.glycolateSeverity.toLowerCase()}`">
          {{ coolantSample.glycolateDisplay }}
        </dd>
        <dt>Fluoride</dt>
        <dd :class="`severity-id-${coolantSample.fluorideSeverity.toLowerCase()}`">
          {{ coolantSample.fluorideDisplay }}
        </dd>
      </dl>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CoolantSampleDetailSampleInfo',
  props: {
    coolantSample: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sample-info {
  border-top: dotted 2px $black;
  display: flex;
  flex-basis: 100%;
  flex-flow: row nowrap;
  margin-top: 10px;
  padding-top: 10px;

  .section-title {
    font-style: italic;
  }

  .severity-id {
    &-reportable {
      background: nth($severity-color-reportable, 2);
    }

    &-abnormal {
      background: nth($severity-color-abnormal, 2);
    }

    &-critical {
      background: nth($severity-color-critical, 2);
    }

    @media print {
      &-reportable {
        background: repeating-linear-gradient(
          45deg,
          nth($severity-color-reportable, 1),
          nth($severity-color-reportable, 1) 10px,
          nth($severity-color-reportable, 2) 10px,
          nth($severity-color-reportable, 2) 20px
        );
      }

      &-abnormal {
        background: repeating-linear-gradient(
          -45deg,
          nth($severity-color-abnormal, 1),
          nth($severity-color-abnormal, 1) 10px,
          nth($severity-color-abnormal, 2) 10px,
          nth($severity-color-abnormal, 2) 20px
        );
      }

      &-critical {
        background: repeating-linear-gradient(
          0deg,
          nth($severity-color-critical, 1),
          nth($severity-color-critical, 1) 10px,
          nth($severity-color-critical, 2) 10px,
          nth($severity-color-critical, 2) 20px
        );
      }
    }
  }

  .metals,
  .fluid-properties {
    flex-basis: 40%;

    &-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

      dl {
        margin: 0;
      }
    }
  }

  .advanced-fluid-properties {
    flex-basis: 20%;
  }

  .fluid-properties,
  .advanced-fluid-properties {
    border-left: dotted 2px $black;
  }

  .metals,
  .fluid-properties,
  .advanced-fluid-properties {
    padding: 10px;

    h3 {
      margin-left: 23px;
      color: $accent;
    }

    dl {
      width: 100%;
    }

    dl dt,
    dl dd {
      border-bottom: solid 1px #ddd;
      padding-top: 2px;
      display: block;
    }

    dt {
      float: left;
      font-weight: bold;
      padding: 2px 6px 0 6px;

      &::after {
        content: ':';
        margin-right: 5px;
      }
    }

    dd {
      display: table;
      min-height: 20px;
      text-align: right;
      padding: 2px 6px 0 6px;
      margin-right: 5px;
    }
  }
}
</style>
